import { Uploader, Loader } from "rsuite";
import { Button } from "@/Components/UI";
import React, { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "@/Contexts/AuthContext";
import { niceBytes } from "@/Helpers/FileHelper";
import "./WordUploader.css";
import { GlobalContext } from "../../../Contexts/GlobalContext";

const WORD_ACCEPT =
  ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

const SCWordUploader = ({
  uploadUrl,
  value,
  onChange,
  onUploadSuccess,
  maxSizeInBytes,
  showRemoveFile,
  disabled,
}) => {
  const { t } = useTranslation();
  const { loginUser } = useContext(AuthContext);
  const { errorHandler } = useContext(GlobalContext);
  const [uploading, setUploading] = React.useState(false);
  const [fileName, setFileName] = React.useState(null);
  const [file, setFile] = React.useState({
    name: null,
    location: null,
    fileGuid: null,
  });

  const validateFile = (file) => {
    if (maxSizeInBytes && file.size > maxSizeInBytes) {
      errorHandler(
        t("The selected file is too big (max. {{max}})", {
          max: niceBytes(maxSizeInBytes),
        }),
      );
      setUploading(false);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (value) {
      setFileName(value.name);
    }
  }, [value]);

  const handleRemoveFile = () => {
    setFileName(null);
    onChange();
  };

  return (
    <div className="sc-word-uploader-container">
      <Uploader
        disabled={disabled}
        draggable
        accept={WORD_ACCEPT}
        className="sc-word-uploader"
        fileListVisible={false}
        headers={{
          Authorization: `Bearer ${loginUser.accessToken}`,
        }}
        action={uploadUrl}
        onUpload={(file) => {
          setUploading(true);
          validateFile(file.blobFile);
        }}
        onSuccess={(response, file) => {
          setUploading(false);
          onUploadSuccess && onUploadSuccess(response, file);
          if (
            response &&
            response.success &&
            response.data &&
            response.data.length
          ) {
            const fileGuid = response.data[0].fileGuid;
            const name = response.data[0].name;
            const location = response.data[0].fileGuid;

            const newFile = {
              fileGuid,
              name,
              location,
            };

            setFileName(name);
            setFile(newFile);
            onChange(newFile);
          }
        }}
        onError={(error) => {
          setUploading(false);
          console.error("Upload error", error);
        }}
      >
        <div className="sc-word-uploader__content">
          <span className="sc-word-uploader__icon">📄</span>
          {fileName && (
            <span className="sc-word-uploader__filename" title={fileName}>
              {fileName}
            </span>
          )}
          <Button style={{ width: "unset" }}>
            {uploading ? (
              <span>
                <Loader /> {t("Uploading")}
              </span>
            ) : (
              <span>
                {t(fileName ? "Upload a different file" : "Upload Word file")}
              </span>
            )}
          </Button>
        </div>
      </Uploader>
      {showRemoveFile && fileName && (
        <Button className="sc-word-uploader__remove" onClick={handleRemoveFile}>
          {t("Remove")}
        </Button>
      )}
    </div>
  );
};

export default SCWordUploader;
